import { Panel } from "primereact/panel";

export default function OverallAnalyticsPanel({ children, headerTitle, headerDescription }: any) {

    const headerTemplate = (
        <div className="panel-header-div">
            <div className="panel-header-name">
                <div className="panel-header-title">
                    <span>{headerTitle}</span>
                </div>
                {headerDescription &&
                    <div className="panel-header-description">
                        <span>{headerDescription}</span>
                    </div>
                }
            </div>
        </div>
    )

    return (
        <Panel className="overall-analytics-panel" headerTemplate={headerTemplate}>
            {children}
        </Panel>
    )
}
